export const TAXONOMY_BOUND_OPERATORS = {
  op_txt_ends_with: 'ends with',
  op_txt_is: 'is',
  op_txt_contains: 'contains',
  op_txt_starts_with: 'starts with',
};

export const QB_MODALS_CONFIG = {
  replaceQsForm: {
    title: 'Replace form?',
    text: 'Do you want to replace your form with a new one?',
    cancelText: 'Cancel',
    confirmText: 'Yes',
    type: 'info',
  },
};

export const TAXONOMY_BOUND_OPERATOR_DEFAULT = 'op_txt_is';
